import { AxiosResponse } from 'axios';
import axios from '../../common/axiosInterceptor';
import cookie from 'react-cookies';
import { SetterOrUpdater } from 'recoil';

interface ILogoutAjaxReturn {
  /** Success if refresh-token was successfully revoked */
  success: boolean;
  error?: any;
}

interface ILogoutAjax {
  /** Setter to clear out user atom */
  setUserAtom: SetterOrUpdater<any>;
  userid?: string;
  removeAllTokens?: boolean;
}

/**
 * Clear client storage and revoke refresh-token
 * @returns Success if refresh-token was successfully revoked
 */
export const logoutAjax = async ({
  setUserAtom,
  userid,
  removeAllTokens,
}: ILogoutAjax): Promise<ILogoutAjaxReturn> => {
  try {
    // clear local storage
    sessionStorage.setItem('redirect_url', '/');
    sessionStorage.setItem('logout', 'true');
    localStorage.removeItem('user');
    localStorage.removeItem('refreshToken');
    cookie.remove('accessToken', { path: '/' });

    // revoke refresh token on server
    let response: AxiosResponse<any> | undefined;
    const refreshToken = localStorage.getItem('refreshToken');
    if (refreshToken || userid) {
      response = await axios.post(`${process.env.VITE_APP_API_DOMAIN}/logout`, {
        refreshToken,
        userid,
        removeAllTokens,
      });
    }

    // clear out user atom
    setUserAtom({});

    return {
      success: !!response?.data?.success,
    };
  } catch (error) {
    return {
      success: false,
      error,
    };
  }
};
